import * as React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { PortalTooltip } from '@components/PortalTooltip';
import { useFormatPrice } from '@components/PriceLabel/useFormattedPrice';
import { IPrice } from '@containers/ProductListing/model';

import { Separator, StyledInfoIcon } from './styled';

interface DisplayPriceProps {
  label: MessageDescriptor;
  labelValues?: Record<string, string>;
  priceValue: IPrice;
  tooltip?: JSX.Element;
  afterPriceText?: string | JSX.Element;
}

export const DisplayPrice: React.FC<DisplayPriceProps> = ({
  priceValue,
  label,
  labelValues,
  tooltip,
  afterPriceText,
}) => {
  const formatPrice = useFormatPrice();

  return (
    <>
      <Separator> | </Separator>
      <FormattedMessage {...label} values={labelValues} />{' '}
      {formatPrice(priceValue)?.formattedPriceWithCurrency}
      {afterPriceText}
      {tooltip && (
        <PortalTooltip
          interactive={true}
          content={<PortalTooltip.Content>{tooltip}</PortalTooltip.Content>}
        >
          <StyledInfoIcon tabIndex={0} color="icon.disabled" height="1rem" />
        </PortalTooltip>
      )}
    </>
  );
};
